import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';

import { CustomizeContext } from '../contexts/customize';

const MtmLabel = () => {
  const [brandLabel, setBrandLabel] = useState();
  const [kamakuraLabel, setKamakuraLabel] = useState();
  const [brandChecked, setBrandChecked] = useState(false);
  const [kamakuraChecked, setKamakuraChecked] = useState(false);
  const { customizes, setCustomizes } = useContext(CustomizeContext);

  const client = axios.create({
    baseURL: process.env.REACT_APP_API_URL
  });
  const productId = document.getElementById('mtm-customize').dataset.productId;

  const onCheckboxSelect = (e) => {
    const id = e.target.dataset.id;
    const isBrand = id === 'OS03';

    const checked = e.target.checked;
    const label = {
      id,
      value: checked
        ? `${isBrand ? 'ブランド' : '鎌倉'}ネーム無`
        : `${isBrand ? 'ブランド' : '鎌倉'}ネーム有`,
      label: checked
        ? `Without ${isBrand ? 'Fabric' : 'Brand'} Label`
        : `With ${isBrand ? 'Fabric' : 'Brand'} Label`
    };

    if (isBrand) {
      setBrandChecked(checked);
      setCustomizes((prev) => ({
        ...prev,
        brand_name: { ...label }
      }));
    } else {
      setKamakuraChecked(checked);
      setCustomizes((prev) => ({
        ...prev,
        kamakura_name: { ...label }
      }));
    }
  };

  useEffect(() => {
    const getBrandLabel = async () => {
      const response = await client.get(`/get_brand_name_option?product_id=${productId}`);
      const label = {
        id: response.data.result[0].id,
        value: response.data.result[0].value,
        label: response.data.result[0].label
      };
      setCustomizes((prev) => ({
        ...prev,
        brand_name: label
      }));
      return response.data.result[1];
    };

    const getKamakuraLabel = async () => {
      const response = await client.get(`/get_name_option?product_id=${productId}`);
      const label = {
        id: response.data.result[0].id,
        value: response.data.result[0].value,
        label: response.data.result[0].label
      };
      setCustomizes((prev) => ({
        ...prev,
        kamakura_name: label
      }));
      return response.data.result[1];
    };

    Promise.allSettled([getBrandLabel(), getKamakuraLabel()])
      .then((data) => {
        setBrandLabel(data[0].value);
        setKamakuraLabel(data[1].value);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    const reorderRaw = sessionStorage.getItem('reorder_properties');
    if (!reorderRaw) return;

    const reorderData = JSON.parse(reorderRaw);

    if (reorderData._Kamakura_Name) {
      const withoutKamakura = reorderData._Kamakura_Name.includes('Without');
      setKamakuraChecked(withoutKamakura);
      setCustomizes((prev) => ({
        ...prev,
        kamakura_name: {
          id: customizes.kamakura_name?.id || '',
          value: withoutKamakura ? '鎌倉ネーム無' : '鎌倉ネーム有',
          label: withoutKamakura ? 'Without Brand Label' : 'With Brand Label'
        }
      }));
    }

    if (reorderData._Brand_Name) {
      const withoutBrand = reorderData._Brand_Name.includes('Without');
      setBrandChecked(withoutBrand);
      setCustomizes((prev) => ({
        ...prev,
        brand_name: {
          id: customizes.brand_name?.id || '',
          value: withoutBrand ? 'ブランドネーム無' : 'ブランドネーム有',
          label: withoutBrand ? 'Without Fabric Label' : 'With Fabric Label'
        }
      }));
    }
  }, [brandLabel, kamakuraLabel]);

  return (
    <div className="mtm-item__wrapper" id="mtm-label">
      <div className="d-flex align-items-center flex-column flex-md-row mb-5">
        <h3 className="mtm-item__title mb-0">LABEL</h3>
      </div>
      <div className="row w-100">
        {brandLabel && (
          <div className="col-12 col-md-6">
            <label
              className={`${brandLabel.description ? 'py-5' : 'py-4'} mtm-label_container mtm-label_container-sp`}
            >
              <div>
                <input
                  type="checkbox"
                  value={brandLabel.value}
                  checked={brandChecked}
                  onChange={onCheckboxSelect}
                  data-id={brandLabel.id}
                  data-label={brandLabel.label}
                />
                <span className="mtm-label_checkbox me-3" />
                <span className="mtm-label_checkbox-label">
                  {brandLabel.label}
                </span>
              </div>
              {brandLabel.description && <p>{brandLabel.description}</p>}
            </label>
          </div>
        )}
        {kamakuraLabel && (
          <div className="col-12 col-md-6">
            <label
              className={`${kamakuraLabel.description ? 'py-5' : 'py-4'} mtm-label_container`}
            >
              <div>
                <input
                  type="checkbox"
                  value={kamakuraLabel.value}
                  checked={kamakuraChecked}
                  onChange={onCheckboxSelect}
                  data-id={kamakuraLabel.id}
                  data-label={kamakuraLabel.label}
                />
                <span className="mtm-label_checkbox me-3" />
                <span className="mtm-label_checkbox-label">
                  {kamakuraLabel.label}
                </span>
              </div>
              {kamakuraLabel.description && <p>{kamakuraLabel.description}</p>}
            </label>
          </div>
        )}
      </div>
    </div>
  );
};

export default MtmLabel;
